export default {
    data: () => {
        return {
            paginationData: {}
        };
    },
    methods: {
        setPaginatorData (requestData) {
            this.paginationData = {
                prev_page_url: requestData?.links?.prev,
                first_page_url: requestData?.links?.first,
                next_page_url: requestData?.links?.next,
                current_page: requestData?.meta?.current_page,
            };
        },
    }
};
